import React, { useState, useEffect } from 'react';
import {
  MDBContainer,
  MDBRow,   
  MDBCol,   
} from 'mdb-react-ui-kit';


import Modal from 'react-modal';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; 


function Photogallery() {
  const [modalShow, setModalShow] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Modal.setAppElement('#root');
  }, []);

  const images = [
    {
      src: 'img/photogallery/1.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/2.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/3.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/4.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/5.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/6.jpg',
      alt: 'Krane Station',
    },




    {
      src: 'img/photogallery/1b.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/2b.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/3b.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/4b.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/5b.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/6b.jpg',
      alt: 'Krane Station',
    },



    {
      src: 'img/photogallery/1c.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/2c.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/3c.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/4c.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/5c.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/6c.jpg',
      alt: 'Krane Station',
    },



    {
      src: 'img/photogallery/1d.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/2d.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/3d.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/4d.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/5d.jpg',
      alt: 'Krane Station',
    },
    {
      src: 'img/photogallery/6d.jpg',
      alt: 'Krane Station',
    },




    
  ];

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setModalShow(true);
  };

  const handleCloseModal = () => {
    setModalShow(false);
  };





  const handleKeyDown = (event) => {
    if (modalShow) {
      if (event.keyCode === 37) {
        // Flecha izquierda
        handleCarouselPrev();
      } else if (event.keyCode === 39) {
        // Flecha derecha
        handleCarouselNext();
      }
    }
  };

  const handleCarouselPrev = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : images.length - 1
    );
  };

  const handleCarouselNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex < images.length - 1 ? prevIndex + 1 : 0
    );
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalShow]);










  return (
    <div className='Photogallery'>

<div className='prizes-txt'>
        <h1>Gallery</h1>
        <h2>Some of our amazing prizes</h2>
      </div>


      <MDBRow className='g-2' id='margin'>
         {/* Primera columna */}
        
         <MDBCol lg={4} md={6} className='img-mar custom-col-md-6' id="photoSize">
           <span onClick={() => handleImageClick(0)}>
             <img
               src='img/photogallery/1.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(1)}>
             <img
               src='img/photogallery/2-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Segunda columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(2)}>
             <img
               src='img/photogallery/3-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(3)}>
             <img
               src='img/photogallery/4.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Tercera columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(4)}>
             <img
               src='img/photogallery/5.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(5)}>
             <img
               src='img/photogallery/6-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>






         {/* x */}


         <MDBCol lg={4} md={6} className='img-mar'  id="photoSize">
           <span onClick={() => handleImageClick(6)}>
             <img
               src= 'img/photogallery/1b.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(7)}>
             <img
               src='img/photogallery/2b-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Segunda columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(8)}>
             <img
               src='img/photogallery/3b-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(9)}>
             <img
               src='img/photogallery/4b.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Tercera columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(10)}>
             <img
               src='img/photogallery/5b.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(11)}>
             <img
               src='img/photogallery/6b-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>


{/* x */}



<MDBCol lg={4} md={6} className='img-mar'  id="photoSize">
           <span onClick={() => handleImageClick(12)}>
             <img
               src='img/photogallery/1c.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(13)}>
             <img
               src='img/photogallery/2c-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Segunda columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(14)}>
             <img
               src='img/photogallery/3c-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(15)}>
             <img
               src='img/photogallery/4c.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

         {/* Tercera columna */}
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(16)}>
             <img
               src='img/photogallery/5c.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(17)}>
             <img
               src='img/photogallery/6c-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>







         <MDBCol lg={4} md={6} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(18)}>
             <img
               src= 'img/photogallery/1d.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(19)}>
             <img
               src='img/photogallery/2d-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>

      
         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(20)}>
             <img
               src='img/photogallery/3d-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(21)}>
             <img
               src='img/photogallery/4d.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>


         <MDBCol lg={4} className='img-mar' id="photoSize">
           <span onClick={() => handleImageClick(22)}>
             <img
               src='img/photogallery/5d.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
           <span onClick={() => handleImageClick(23)}>
             <img
               src='img/photogallery/6d-vertical.jpg'
               className='w-100 shadow-1-strong rounded mb-2 photogallery-image'
               alt='Krane Station'
               style={{ cursor: 'pointer' }}
             />
           </span>
         </MDBCol>





       </MDBRow>

       <Modal
  isOpen={modalShow}
  onRequestClose={handleCloseModal}
  style={{
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.75)',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      position: 'relative',
      inset: 'unset',
      width: '90vw',
      maxWidth: '1200px',
      maxHeight: '90vh',
      padding: '20px',
      overflow: 'auto',
    }
  }}>
  {/* Contenido del modal */}
  <Carousel selectedItem={selectedImageIndex || 0} showThumbs={false}>
    {images.map((image, index) => (
      <div key={index}>
        <img
          className="d-block w-100"
          src={image.src}
          alt={image.alt}
          style={{
            maxHeight: '700px', 
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>
    ))}
  </Carousel>
  <button className='btn-modal' onClick={handleCloseModal}>
    Close
  </button>
</Modal>


      







    </div>
  );
}

export default Photogallery;






